var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountain = function SvgMountain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#282D2D",
    strokeWidth: 3.333,
    d: "m34 32-9.588-16.76M2 32l9.039-15.809m0 0L18 4l6.412 11.24m-13.373.951c1.067 3.642 4.946 2.801 6.961 1.335 2.37-1.724 3.995-2.683 6.412-2.285"
  })));
};
export default SvgMountain;